export function Field({ label, children, full }) {
    return (
        <div className={full ? "md:col-span-2" : ""}>
            <label className="overline block mb-2">{label}</label>
            {children}
        </div>
    );
}

